import React, { useEffect, useState } from 'react'
import CategoryRow from './category-row'
import "moment/locale/ja";
import ajax from '../../common/components/ajax.jsx'
import Constants from '../../common/components/constants.jsx'
import { Button } from '@mui/material';
import { Table } from '@mui/material';
import { Modal } from '@mui/material';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { TextField } from '@mui/material';
import ContentHeader from './content-header';
import CreateIcon from '@mui/icons-material/Create';
import Dialog from '@mui/material/Dialog/Dialog.js'
import DialogContent from '@mui/material/DialogContent/DialogContent.js'
import { DialogTitle } from '@mui/material'
import { DialogActions } from '@mui/material'
import { DialogContentText } from '@mui/material'

function Category(props) {

    const [createAuthorized, setCreateAuthorized] = useState("")
    const [editAuthorized, setEditAuthorized] = useState("")
    const [deleteAuthorized, setDeleteAuthorized] = useState("")

    const [items, setItems] = useState(props.categories);

    const [createModalIsOpen, setCreateModalIsOpen] = useState(false);
    const [editModalIsOpen, setEditModalIsOpen] = useState(false);
    const [alertModalIsOpen,setAlertModalIsOpen] = useState(false)
    const [loadModalIsOpen, setLoadModalIsOpen] = useState(false);
    const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false) 

    const [alertTitle, setAlertTitle] = useState('');
    const [alertBody, setAlertBody] = useState('');

    const [NEW_CATEGORY_NAME, setNewCategoryName] = useState(
        props.NEW_CATEGORY_NAME
    );

    const [EDIT_CATEGORY_ID, setEditCategoryId] = useState(
        props.EDIT_CATEGORY_ID
    );
    const [EDIT_CATEGORY_NAME, setEditCategoryName] = useState(
        props.EDIT_CATEGORY_NAME
    );
    const [EDIT_CATEGORY_IS_SPECIAL, setEditCategoryIsSpecial] = useState(
        props.EDIT_CATEGORY_IS_SPECIAL
    );

    const [DELETE_CATEGORY_NAME, setDeleteCategoryName] = useState(
        props.DELETE_CATEGORY_NAME
    );
    const [DELETE_CATEGORY_ID, setDeleteCategoryId] = useState(
        props.DELETE_CATEGORY_ID
    );
    const [DELETE_CATEGORY_IS_SPECIAL, setDeleteCategoryIsSpecial] = useState(
        props.DELETE_CATEGORY_IS_SPECIAL
    );
    useEffect(()=>{

        const createAuthorized = (
            props.auth.hasOwnProperty('role') &&
            props.auth.role.hasOwnProperty('CREATE_CATEGORY') &&
            props.auth.role.CREATE_CATEGORY
        );
        const editAuthorized = (
            props.auth.hasOwnProperty('role') &&
            props.auth.role.hasOwnProperty('EDIT_CATEGORY') &&
            props.auth.role.EDIT_CATEGORY
        );
        const deleteAuthorized = (
            props.auth.hasOwnProperty('role') &&
            props.auth.role.hasOwnProperty('DELETE_CATEGORY') &&
            props.auth.role.DELETE_CATEGORY
        );
        setCreateAuthorized(createAuthorized)
        setEditAuthorized(editAuthorized)
        setDeleteAuthorized(deleteAuthorized)
        setItems(props.categories)

    },[props])
                
    const toggleAlertModal = () => {
        setAlertModalIsOpen(!alertModalIsOpen);
    };
    
    const toggleCreateModal = () => {
        setCreateModalIsOpen(!createModalIsOpen);
    };
    
    const onChangeNewTitle = (val) => {
        if (!createAuthorized) return;
        setNewCategoryName(val);
    };

    const onSubmitCreateCategory = () => {
        if (!createAuthorized) return;
        if (!NEW_CATEGORY_NAME) {
            setAlertTitle('入力チェックエラー');
            setAlertBody('カテゴリ名を入力してください');
            toggleAlertModal();
            return;
        }
        postCreateCategory();
    };

    /**
     * カテゴリ追加の送信
     */
    const postCreateCategory = () => {
        setLoadModalIsOpen(true)

        const postData = {
            category_name: NEW_CATEGORY_NAME
        };

        ajax.post(
            Constants.URLs.CREATE_CATEGORY,
            postData,
            (successJson) => {
                setLoadModalIsOpen(false)
                toggleCreateModal();
                props.loadCategoryList();
            },
            (errorJson) => {
                setAlertTitle(errorJson.response);
                setAlertBody(errorJson.message + errorJson.code);
                setAlertModalIsOpen(true)
                setLoadModalIsOpen(false)
            }
        );
    };

    // ------------------------------------------------------------------------
    // カテゴリ編集
    // ------------------------------------------------------------------------

    const toggleEditModal = () => {
        setEditModalIsOpen(!editModalIsOpen);
    };

    const onChangeEditTitle = (val) => {
        if (!editAuthorized) return;
        setEditCategoryName(val);
    };

    const editCategory = (item) => {
        if (!editAuthorized) return;

        setEditCategoryId(item.CATEGORY_ID);
        setEditCategoryName(item.CATEGORY_NAME);
        setEditCategoryIsSpecial(item.SPECIAL_CATEGORY);
        toggleEditModal();
    };

    const onSubmitEditCategory = () => {
        if (!editAuthorized) return;
        if (EDIT_CATEGORY_IS_SPECIAL) {
            setAlertTitle('入力チェックエラー');
            setAlertBody('特別カテゴリを編集することはできません');
            setAlertModalIsOpen(true)
            return;
        }
        if (!EDIT_CATEGORY_ID) {
            setAlertTitle('入力チェックエラー');
            setAlertBody('カテゴリを選択してください');
            setAlertModalIsOpen(true)
            return;
        }
        if (!EDIT_CATEGORY_NAME) {
            setAlertTitle('入力チェックエラー');
            setAlertBody('カテゴリ名を入力してください');
            setAlertModalIsOpen(true)
            return;
        }
        postEditCategory();
    };
    
    /**
     * カテゴリ編集の通信
     */
    const postEditCategory = () => {
        setLoadModalIsOpen(true)
        if (EDIT_CATEGORY_IS_SPECIAL) {
            setAlertTitle('エラー');
            setAlertBody('特別カテゴリを編集することはできません');
            setAlertModalIsOpen(true)
            setLoadModalIsOpen(false)
            return;
        }

        const postData = {
            category_id: EDIT_CATEGORY_ID,
            category_name: EDIT_CATEGORY_NAME,
        };

        ajax.post(
            Constants.URLs.EDIT_CATEGORY,
            postData,
            (successJson) => {
                setLoadModalIsOpen(false)
                toggleEditModal();
                props.loadCategoryList();
            },
            (errorJson) => {
                setAlertTitle(errorJson.response);
                setAlertBody(errorJson.message + errorJson.code);
                setAlertModalIsOpen(true)
                setLoadModalIsOpen(false)
            }
        );
    };
    
    // ------------------------------------------------------------------------
    // カテゴリ削除
    // ------------------------------------------------------------------------
    const toggleDeleteModal = () => {
        setDeleteModalIsOpen(!deleteModalIsOpen);
    };

    const deleteCategory = (item) => {
        if (!deleteAuthorized) return;

        setDeleteCategoryId(item.CATEGORY_ID);
        setDeleteCategoryName(item.CATEGORY_NAME);
        setDeleteCategoryIsSpecial(item.SPECIAL_CATEGORY);
        toggleDeleteModal();
    };

    const onSubmitDeleteCategory = () => {
        if (!deleteAuthorized) return;
        if (DELETE_CATEGORY_IS_SPECIAL) {
            setAlertTitle('エラー');
            setAlertBody('特別カテゴリを削除することはできません');
            setAlertModalIsOpen(true)
            return;
        }
        postDeleteCategory();
    };
    
    /**
     * カテゴリ削除の通信
     */
    const postDeleteCategory = () => {
        setLoadModalIsOpen(true)
        if (DELETE_CATEGORY_IS_SPECIAL) {
            setAlertTitle('エラー');
            setAlertBody('特別カテゴリを削除することはできません');
            setAlertModalIsOpen(true)
            setLoadModalIsOpen(false)
            return;
        }

        const postData = {
            category_id: DELETE_CATEGORY_ID,
            category_name: DELETE_CATEGORY_NAME
        };

        ajax.post(
            Constants.URLs.DELETE_CATEGORY,
            postData,
            (successJson) => {
                setLoadModalIsOpen(false)
                toggleDeleteModal();
                props.loadCategoryList();
            },
            (errorJson) => {
                setAlertTitle(errorJson.response);
                setAlertBody(errorJson.message + errorJson.code);
                setAlertModalIsOpen(true)
                setLoadModalIsOpen(false)
            }
        );
    };

    const updateSortItems = (items) => {
        setItems(items);
    };

    return(
        <div id="Category">
                <ContentHeader title={"カテゴリ管理"} breadCrumbItems={[
                {title:"カテゴリ管理",icon:"notification",path:""}
                ]}/>
                <div style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: "20px"
                }}>
                    <Button
                        variant="contained"
                        startIcon={<CreateIcon />}
                        color={"primary"}
                        disableElevation
                        onClick={() => { toggleCreateModal(); }}
                    >
                        新規カテゴリの追加
                    </Button>
                </div>
                <CategoryRow
                 items={items}
                 auth={props.auth}
                 editCategory={(items) => { editCategory(items); }}
                 updateSortItems={(items) => { updateSortItems(items); }}
                 deleteCategory={(item) => { deleteCategory(item); }} 
                />

            <Dialog
              open={createModalIsOpen}
              onClose={() => {toggleCreateModal()}}
              aria-labelledby="form-dialog-title"
              maxWidth={"sm"}
              fullWidth={true}
            >
                <DialogTitle id="form-dialog-title" variant="h6" component="h2">
                    カテゴリの新規作成
                </DialogTitle>
                <DialogContent>
                      <DialogContentText>
                          カテゴリのタイトルを入力してください
                      </DialogContentText>
                      <TextField
                        id="standard-basic"
                        autoFocus
                        fullWidth
                        variant="standard"
                        margin="normal"
                        disabled={!createAuthorized}
                        label="カテゴリ名"
                        onChange={(evt) => onChangeNewTitle(evt.target.value)}
                      />
                </DialogContent>
                <DialogActions>
                      <Button onClick={toggleCreateModal} color="primary">
                        キャンセル
                      </Button>
                      <Button
                        disabled={!createAuthorized}
                        variant="contained"
                        color="primary"
                        onClick={onSubmitCreateCategory}
                      >
                          作成
                      </Button>
                </DialogActions>
            </Dialog>

            <Dialog
              open={editModalIsOpen}
              onClose={() => {toggleEditModal()}}
              aria-labelledby="form-dialog-title"
              maxWidth={"sm"}
              fullWidth={true}
            >
                <DialogTitle id="form-dialog-title" variant="h6" component="h2">
                    カテゴリ名の編集
                </DialogTitle>
                <DialogContent>
                      <DialogContentText>
                          カテゴリのタイトルを編集してください
                      </DialogContentText>
                      <TextField
                        id="standard-basic"
                        autoFocus
                        fullWidth
                        variant="standard"
                        margin="normal"
                        disabled={!editAuthorized}
                        label="カテゴリ名"
                        value={EDIT_CATEGORY_NAME}
                        onChange={(evt) => onChangeEditTitle(evt.target.value)}
                      />
                </DialogContent>
                <DialogActions>
                      <Button onClick={toggleEditModal} color="primary">
                        キャンセル
                      </Button>
                      <Button
                        disabled={!createAuthorized}
                        variant="contained"
                        color="primary"
                        onClick={onSubmitEditCategory}
                      >
                          保存
                      </Button>
                </DialogActions>
            </Dialog>

    <Dialog
      open={deleteModalIsOpen}
      onClose={toggleDeleteModal}
      aria-labelledby="alert-modal-title"
      maxWidth={"sm"}
      fullWidth={true}
    >
      <DialogTitle id="alert-modal-title">カテゴリの削除</DialogTitle>
        <DialogContent>
          <DialogContentText>
              カテゴリ「{DELETE_CATEGORY_NAME}」を削除します。よろしいですか？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={toggleDeleteModal}>
            キャンセル
          </Button>
          <Button
            disabled={!deleteAuthorized}
            color="primary"
            onClick={onSubmitDeleteCategory}
          >
            削除
          </Button>
        </DialogActions>
    </Dialog>

    <Dialog
      open={alertModalIsOpen}
      onClose={toggleAlertModal}
      aria-labelledby="alert-modal-title"
      maxWidth={"sm"}
      fullWidth={true}
    >
      <DialogTitle id="alert-modal-title">{alertTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>
                {alertBody}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={toggleAlertModal}>
            閉じる
          </Button>
        </DialogActions>
    </Dialog>
    </div>
    )
}
export default Category


Category.defaultProps = {
    role: {},
    NEW_TOPIC_IMAGE_ATTACH:   0,
    EDIT_TOPIC_IMAGE_ATTACH:  0,
    NEW_TOPIC_IMAGE_COMMENT:  '',
    EDIT_TOPIC_IMAGE_COMMENT: ''
};
